import type { TiptapDoc } from '@odo/shared-ui';

export function getReasonText(payload: Record<string, unknown>): string | null {
    const raw = payload.reason;
    return typeof raw === 'string' && raw.trim() !== '' ? raw : null;
}

export function getReasonDoc(payload: Record<string, unknown>): TiptapDoc | null {
    const rawDoc = payload.reasonDoc;
    return rawDoc &&
        typeof rawDoc === 'object' &&
        Array.isArray((rawDoc as { content?: unknown }).content)
        ? (rawDoc as TiptapDoc)
        : null;
}

/** Whether an 'in-office-hold-note' payload has anything worth rendering -
 *  checked separately from the component itself so OdoNoteCard can decide
 *  whether to show the card at all without rendering twice. */
export function hasInOfficeHoldNoteContent(payload: Record<string, unknown>): boolean {
    return !!(getReasonText(payload) || getReasonDoc(payload));
}
